import React, { useEffect, useState } from "react";
import { getToken } from "../../../../utils/token";
import { useLoaderData } from "react-router-dom";
import instance from "../../../../axios/instance";

import { ToastContainer, toast } from "react-toastify";
import {
  ArrowLeft2,
  ArrowRight2,
  CloseSquare,
  Refresh,
  SearchNormal,
  Sort,
  Trash,
} from "iconsax-react";
import { PaginationButton } from "../../../../components/PaginationButton";
import { DoctorItem } from "../../../../components/modals/doctor/DoctorItem";
import AddNewDoctor from "../../../../components/modals/doctor/AddNewDoctor";

export const facilityDoctorsLoader = async () => {
  const token = getToken();
  const doctor = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const res = await instance.get(
    "/doctor/facility/doctors",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return {doctors: res.data, _doctor: doctor.data}
};

export const DoctorsPage = () => {
  const {doctors, _doctor} = useLoaderData();
  const [doctorsList, setDoctorsList] = useState(
    [...doctors].map((_, index) => ({ ..._, index: index + 1 }))
  );
  const [filteredList, setFilteredList] = useState(
    doctorsList.filter((_, index) => index + 1 <= 10)
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [sorted, setSorted] = useState("");
  const [currentDoctor, setCurrentDoctor] = useState(null);
  const [isAddDoctorModalOpen, setIsAddDoctorModalOpen] = useState(false);

  useEffect(() => {
    setDoctorsList(() =>
      doctors.map((_, index) => ({ ..._, index: index + 1 }))
    );
  }, [doctors]);

  const handleSearch = (e) => {
    e.preventDefault();

    const query = searchQuery.toLowerCase();
    setFilteredList(() => {
      return doctorsList
        .filter((doctor) => {
          const firstName = doctor.firstname.toLowerCase().includes(query);
          const lastName = doctor.lastname.toLowerCase().includes(query);
          const email = doctor.email.toLowerCase().includes(query);

          return doctor.id === query || firstName || lastName || email;
        })
        .filter((_, index) => index + 1 <= 10);
    });
  };

  useEffect(() => {
    setFilteredList(() =>
      doctorsList.filter(
        (_, index) =>
          index + 1 > 10 * (pageIndex - 1) && index + 1 <= 10 * pageIndex
      )
    );
  }, [pageIndex, doctorsList]);

  const handleSort = (def) => {
    switch (def) {
      case "index": {
        setPageIndex(1);
        if (sorted !== "index") {
          setSorted("index");
        } else {
          setSorted("");
        }
        doctorsList.reverse();
        setDoctorsList(doctorsList);
        setFilteredList((items) =>
          doctorsList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "name": {
        setPageIndex(1);
        if (sorted === "name") {
          setSorted("");
          doctorsList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("name");
          doctorsList.sort((a, b) => {
            if (a.lastname < b.lastname) return -1;
            if (a.lastname > b.lastname) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          doctorsList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "gender": {
        setPageIndex(1);
        if (sorted === "gender") {
          setSorted("");
          doctorsList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("gender");
          doctorsList.sort((a, b) => {
            if (a.gender < b.gender) return -1;
            if (a.gender > b.gender) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          doctorsList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "status": {
        setPageIndex(1);
        if (sorted === "status") {
          setSorted("");
          doctorsList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("status");
          doctorsList.sort((a, b) => {
            if (a.account_status < b.account_status) return -1;
            if (a.account_status > b.account_status) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          doctorsList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
    }
  };


  return (
    <div className="bg-[#fafafa] max-w-[100%] w-full px-7 py-5 h-[90vh]">
      
      <AddNewDoctor
        isOpen={isAddDoctorModalOpen}
        onClose={() => setIsAddDoctorModalOpen(false)}
        triggerRevalidate={() => window.location.reload()}
      />
      

      <div className="flex justify-between items-center">
        <div className="text-2xl font-bold">
          All Members ({doctorsList.length})
        </div>

        <div className="flex gap-2 items-center">
          <button
            onClick={() => location.reload()}
            className="bg-[#00b0ad0d] py-2 px-3 text-primary flex gap-2 items-center rounded-md font-medium text-[14px] hover:opacity-80"
          >
            Refresh <Refresh size={16} />
          </button>
          {_doctor.access === 'admin' && (
          <button
            onClick={() => setIsAddDoctorModalOpen(true)}
            className="bg-primary py-2 px-3 shadow-sm rounded-md font-medium text-[14px] hover:opacity-80 text-white"
          >
            Add Member +
          </button>
          )}
        </div>
      </div>

      <div className="border bg-white rounded-md overflow-x-scroll scrollbar-hide mt-4">
        <div className="flex justify-between p-2 items-center">
          <form className="relative" onSubmit={handleSearch}>
            <input
              className="outline-none h-[40px] w-[300px] border rounded-md p-2 placeholder:font-normal placeholder:text-[14px] text-sm"
              placeholder="Search doctor by name/email/id"
              name="query"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="absolute h-[38px] rounded-md top-1/2 -translate-y-1/2 right-[1px] w-[30px] flex items-center justify-center bg-white cursor-pointer hover:text-primary duration-300"
              type="submit"
            >
              <SearchNormal size={15} />
            </button>
          </form>

          <div className="flex gap-2 items-center">
            <PaginationButton
              item={<ArrowLeft2 size={16} />}
              disabled={pageIndex <= 1}
              handleClick={() => setPageIndex(pageIndex - 1)}
            />
            <span className="font-light text-xs">Page {pageIndex}</span>
            <PaginationButton
              item={<ArrowRight2 size={16} />}
              disabled={pageIndex >= Math.ceil(doctorsList.length / 10)}
              handleClick={() => setPageIndex((index) => index + 1)}
            />
          </div>
        </div>

        <div className="max-h-[80vh] overflow-y-scroll scrollbar-hide">
          <table className="w-full relative whitespace-nowrap">
            <thead>
              <tr className="uppercase h-14 font-bold bg-[#f1f1f1] text-gray-700 text-[12px]">
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("index")}
                >
                  #{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "index" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4">Member ID</td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("name")}
                >
                  Fullname{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "name" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("gender")}
                >
                  Gender{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "gender" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4">Email</td>
                <td className="px-6 py-4">Specialty Role</td>
                <td className="px-6 py-4">App Role</td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("status")}
                >
                  Status{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "status" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4"></td>
              </tr>
            </thead>

            <tbody>
              {filteredList.length < 1 ? (
                <tr>
                  <td className="px-6 py-4 font-normal" colSpan={6}>
                    You do not have any member yet
                  </td>
                </tr>
              ) : (
                filteredList.map((doctor, index) => (
                  <tr
                    key={doctor.id}
                    className={`${_doctor.id === doctor.id ? 'bg-[#f9f9f9]': ''} h-14 text-[14px] font-normal border-b`}
                  >
                    <td className="px-6 py-4">{doctor.index}</td>
                    <td
                      className="px-6 py-4 underline text-primary cursor-pointer"
                      onClick={() => setCurrentDoctor(doctor)}
                    >
                      {doctor.id}
                    </td>
                    <td className="px-6 py-4">
                      {doctor.prefix ? `${doctor.prefix}.` : ''} {doctor.lastname} {doctor.firstname}
                    </td>
                    <td className="px-6 py-4">{doctor.gender}</td>
                    <td className="px-6 py-4">{doctor.email}</td>
                    <td className="px-6 py-4 capitalize">{doctor.specialty === 'doctor' || doctor.specialty === 'nurse' ? 'Doctor/nurse' : doctor.specialty}</td>
                    <td className="px-6 py-4">
                      {doctor.access === "doc" ? "Member" : "Admin"}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`${
                          doctor.account_status !== "active"
                            ? "bg-red-100"
                            : "bg-green-100"
                        } max-w-[100px] w-full text-center inline-block capitalize py-[2px] px-2 rounded-md`}
                      >
                        {doctor.account_status}
                      </span>
                    </td>
                    {/* <td
                      className="px-6 py-4 underline cursor-pointer duration-300 hover:text-[tomato]"
                      onClick={() => setDeleteDoctor(doctor)}
                    >
                      <Trash size={24} />
                    </td> */}
                    <td
                      className="px-6 py-4 underline text-primary cursor-pointer"
                      onClick={() => setCurrentDoctor(doctor)}
                    >
                      View member
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {currentDoctor && (
        <DoctorItem
          doctor={currentDoctor}
          onClose={() => setCurrentDoctor(null)}
          deactivateActions={_doctor.id === currentDoctor.id || _doctor.access !== 'admin'}
          currentDoctor={_doctor}
          
        />
      )}
      {currentDoctor && (
        <div
          className="fixed z-20 inset-0 bg-[rgba(0,0,0,.2)]"
          onClick={() => setCurrentDoctor(null)}
        />
      )}
    </div>
  );
};

